import { ADVISOR_TYPES } from "../../constants/global.constants";

export const getIsValidAndValidTrains = (plant, advisorType) => {
  const { originalTrains, trains, overall_ca_status, overall_ra_status } =
    plant;

  let isValid = false;
  let validTrains = originalTrains || trains || [];

  if (advisorType === ADVISOR_TYPES.CA_ONLY) {
    isValid = overall_ca_status !== 0;
    if (isValid) {
      validTrains = validTrains.filter(
        ({ cleaning_advisor }) => cleaning_advisor?.available,
      );
    }
  } else if (advisorType === ADVISOR_TYPES.RA_ONLY) {
    isValid = overall_ra_status !== 0;
    if (isValid) {
      validTrains = validTrains.filter(
        ({ lifetime_advisor }) => lifetime_advisor?.available,
      );
    }
  } else {
    isValid = overall_ra_status !== 0 && overall_ca_status !== 0;
    if (isValid) {
      validTrains = validTrains.filter(
        ({ cleaning_advisor, lifetime_advisor }) =>
          cleaning_advisor?.available && lifetime_advisor?.available,
      );
    }

    // If the plant is valid but when CA prediction done for one train and LA in another train
    if (validTrains.length === 0) {
      isValid = false;
    }
  }

  return { isValid, validTrains };
};
